module.exports = __webpack_public_path__ + "static/media/creator-racquet.1f043fc6.png";